export const getUserBookingsQuery = /* GraphQL */ `
            query GetUser($id: ID!) {
            getUser(id: $id) {
                id
                tickets {
                items {
                    id
                    createdByUserId
                    eventDays
                    status
                    paymentStatus
                    type
                    addons
                    notes
                    invitationCode
                    createdAt
                    updatedAt
                    event {
                        id
                        ticketCancellationDeadline
                        instantPaymentOnly
                        paymentFlow
                        name {
                        language
                        text
                        }
                    }
                    personalAddress {
                        firstName
                        lastName
                    }
                    ticketPaymentId
                    ticketFile {
                        s3Path
                    }
                    __typename
                }
                nextToken
                __typename
                }
                orders {
                items {
                    createdAt
                    id
                    event {
                        id
                        paymentFlow
                        name {
                            language
                            text
                        }
                    }
                    company {
                        id
                        name
                        image {
                            main {
                                fileName
                            }
                        }
                    }
                    deliveryAddress {
                        firstName
                        lastName
                    }
                    billingAddress {
                        firstName
                        lastName
                    }
                    billingEmail
                    totalAmount
                    status
                    paymentStatus
                    financial {
                        taxRate
                        paymentProvider
                        invoiceFile {
                        s3Path
                        }
                        documents {
                            documentType
                            s3Path
                            documentNumber
                            referingDocumentNumber
                            status
                            date
                        }
                    }
                    deliveryStatus
                    lineItems {
                        items {
                        id
                        qty
                        price
                        isCanceled
                        cancelationDate
                        product {
                            id
                        name {
                            language
                            text
                        }
                        price
                        image {
                            main {
                            fileName
                            }
                        }
                        icon
                        type
                        }
                        bookedTicket {
                            id
                            event {
                                id
                                name {
                                    language
                                    text
                                }
                            }
                        }
                        bookedBooth {
                            event {
                                id
                                name {
                                    language
                                    text
                                }
                            }
                        }
                        bookedBoothEquipment {
                            bookedBooth {
                                event {
                                    id
                                    name {
                                        language
                                        text
                                    }
                                }
                            }
                        }
                    }
                        }
                    }
                }
                createdAt
                updatedAt
                owner
                __typename
            }
            }
        `;